import Protection from "components/organisms/somebuddy/Protection"
import useTranslations from "hooks/useTranslations"

export default function Coaches() {
  const {
    proCoachTitle,
    proCoach1Name,
    proCoach1Position,
    proCoach1Title,
    proCoach2Name,
    proCoach2Position,
    proCoach2Title,
    proCoach3Name,
    proCoach3Position,
    proCoach3Title,
  } = useTranslations()
  const features = [
    {
      id: 1,
      name: proCoach1Name,
      position: proCoach1Position,
      // email: protectionEnPreventContactEmail,
      image: "suvi-square.jpg",
      title: proCoach1Title,
    },
    {
      id: 2,
      name: proCoach2Name,
      position: proCoach2Position,
      image: "kaisa-square.jpg",
      title: proCoach2Title,
    },
    {
      id: 3,
      name: proCoach3Name,
      position: proCoach3Position,
      image: "priska-square.jpg",
      title: proCoach3Title,
    },
  ]

  return (
    <Protection
      features={features}
      title={proCoachTitle}
      portraitFirst
      showReadMore
    />
  )
}
